module.exports = __webpack_public_path__ + "static/img/event_image.30b39c6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/doom-yoga/event_image.png
// module id = n2Zx
// module chunks = 0